﻿import {IProgress} from "@2d-front-monorepo/core";
import AttachmentType from "../enums/AttachmentType";
import countAttachments from "./countAttachments";

export default function ensureProgress(attachments: Partial<Record<AttachmentType, FileList>>, label: string, progress?: IProgress): IProgress {
	progress ??= {current: 0, total: 0, label: ""};

	if (progress.total <= 0) {
		progress.total = countAttachments(attachments);
	}

	progress.label = label;
	return progress;
}
